import React, { useState, useEffect, useCallback } from 'react';
import purchaseReportService from '../../../../services/purchaseReportService';
import PriceTrackingShell from './PriceTrackingShell';
import usePriceTrackingFilters from './usePriceTrackingFilters';
import { formatMoney } from './shared';

export default function PriceTrackingSuppliersPage() {
  const { filters, updateFilter, buildParams, suppliers, products } = usePriceTrackingFilters();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await purchaseReportService.getPriceTrackingDashboard(buildParams());
      if (res.success) {
        setRows(res.data?.top_suppliers || []);
      } else {
        setToast({ isOpen: true, message: res.message || 'Error al cargar', type: 'error' });
      }
    } catch (error) {
      setToast({ isOpen: true, message: 'Error al cargar proveedores', type: 'error' });
    } finally {
      setLoading(false);
    }
  }, [buildParams]);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PriceTrackingShell
      title="Proveedores"
      subtitle="Ranking de proveedores por volumen de compra en el período."
      filters={filters}
      updateFilter={updateFilter}
      suppliers={suppliers}
      products={products}
      onQuery={loadData}
      loading={loading}
      toast={toast}
      onToastClose={() => setToast({ ...toast, isOpen: false })}
    >
      <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200">
        <div className="px-5 py-4 border-b">
          <h2 className="font-semibold text-gray-800">Ranking de proveedores</h2>
        </div>
        {loading ? (
          <p className="p-8 text-center text-gray-500">Cargando...</p>
        ) : rows.length === 0 ? (
          <p className="p-8 text-center text-gray-500">Sin datos en el período.</p>
        ) : (
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs text-gray-500 uppercase">#</th>
                <th className="px-4 py-3 text-left text-xs text-gray-500 uppercase">Proveedor</th>
                <th className="px-4 py-3 text-right text-xs text-gray-500 uppercase">Gasto total</th>
                <th className="px-4 py-3 text-right text-xs text-gray-500 uppercase">% participación</th>
                <th className="px-4 py-3 text-right text-xs text-gray-500 uppercase">Documentos</th>
                <th className="px-4 py-3 text-right text-xs text-gray-500 uppercase">Productos</th>
                <th className="px-4 py-3 text-right text-xs text-gray-500 uppercase">Líneas</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {rows.map((row, i) => (
                <tr key={row.supplier_id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-gray-500">{i + 1}</td>
                  <td className="px-4 py-3 font-medium">{row.supplier_name}</td>
                  <td className="px-4 py-3 text-right">{formatMoney(row.total_spend, row.currency)}</td>
                  <td className="px-4 py-3 text-right text-teal-700 font-semibold">{row.share_pct}%</td>
                  <td className="px-4 py-3 text-right">{row.document_count}</td>
                  <td className="px-4 py-3 text-right">{row.product_count}</td>
                  <td className="px-4 py-3 text-right">{row.purchase_lines}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </PriceTrackingShell>
  );
}
